import React from 'react';
import { Button } from 'components';
import { useModifiedTranslation } from 'hooks/useModifiedTranslation';

interface IdleWarningModalProps {
    isOpen: boolean;
    remainingTime: number;
    onContinue: () => void;
    onLogout: () => void;
}

export const IdleWarningModal: React.FC<IdleWarningModalProps> = ({
    isOpen,
    remainingTime,
    onContinue,
    onLogout,
}) => {
    const { t } = useModifiedTranslation();
    
    const countdown = Math.ceil(remainingTime / 1000);

    if (!isOpen) return null;

    const formatTime = (seconds: number) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };

    return (
        <div className="flex fixed inset-0 z-50 justify-center items-center bg-black bg-opacity-50">
            <div className="p-6 mx-4 w-full max-w-md bg-white rounded-lg shadow-xl">
                <div className="flex items-center mb-4">
                    <svg
                        className="mr-3 w-8 h-8 text-orange-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                        />
                    </svg>
                    <h3 className="text-lg font-semibold text-gray-900">
                        {t('utils.idleWarning.title')}
                    </h3>
                </div>

                <p className="mb-4 text-gray-700">
                    {t('utils.idleWarning.message')}
                </p>

                <div className="mb-6 text-center">
                    <div className="text-3xl font-bold text-primary-600">
                        {formatTime(countdown)}
                    </div>
                </div>

                <div className="flex gap-3 justify-center">
                    <Button
                        variant="Red"
                        onClick={onContinue}
                        className="flex-1"
                    >
                        {t('utils.idleWarning.continueSession')}
                    </Button>

                    <Button
                        variant="Dark"
                        onClick={onLogout}
                        className="flex-1"
                    >
                        {t('utils.idleWarning.logout')}
                    </Button>
                </div>
            </div>
        </div>
    );
};
